<page-header [section]="'overview-sys-health'">
  <page-title>Overview</page-title>
  <page-blurb>Display the status summary of the nodes, services, devices, monitors and service logs in
    charts</page-blurb>
</page-header>


<div class="row" *ngIf="show_maintenance">
  <div class="col-auto">
    <button (click)="clear_maintenance($event)" class="btn btn-danger">Clear Maintenance Mode</button>
  </div>
  <div class="col-auto">
    <button (click)="schedule_maintenance($event, scheduleMaintenance)" class="btn btn-warning">Schedule Maintenance
      Mode</button>
  </div>
</div>



<div class="row mb-5">
  <div class="col-12">
    <div class="card shadow-sm border-0">
      <div class="card-body p-4">
        <div #echartContainer1 style="width: 100%; height: 500px; min-height: 440px;"></div>
      </div>
    </div>
  </div>
</div>

<hr class="my-4" style="border-color: #e0e4ea;">

<div class="row mb-5">
  <div class="col-12">
    <div class="card shadow-sm border-0">
      <div class="card-body p-4">
        <div #echartContainer2 style="width: 100%; height: 500px; min-height: 440px;"></div>
      </div>
    </div>
  </div>
</div>

<hr class="my-4" style="border-color: #e0e4ea;">

<div class="row mb-5">
  <div class="col-12">
    <div class="card shadow-sm border-0">
      <div class="card-body p-4">
        <div #echartContainer3 style="width: 100%; height: 500px; min-height: 440px;"></div>
      </div>
    </div>
  </div>
</div>




<!--

<div class="row">
  <div class="col">
    public user_registration_report_daily: any = null;
    <pre>{{user_registration_report_daily | json}}</pre>
  </div>
</div>


<div class="row">
  <div class="col">
    public user_registration_report_hourly: any = null;
    <pre>{{user_registration_report_hourly | json}}</pre>
  </div>
</div>


<div class="row">
  <div class="col">
    public sensor_daily_report: any = null;
    <pre>{{sensor_daily_report | json}}</pre>
  </div>
</div>


<div class="row">
  <div class="col">
    public sensor_hourly_report: any = null;
    <pre>{{sensor_hourly_report | json}}</pre>
  </div>
</div>


<div class="row">
  <div class="col">
    public metric_report: any;
    <pre>{{metric_report | json}}</pre>
  </div>
</div>
-->


<div class="row">
  <div class="col mh-100">

    <div class="row pb-4">
      <div class="col">
        <h1>Nodes</h1>

        <ng-select [(ngModel)]="selected" bindLabel="label" bindValue="value" [items]="nodes"></ng-select>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <ng-container *ngIf="selected">
          <widget [entity]="node_reports[selected]" [options]="{}" [layout]="'card'"></widget>
        </ng-container>
      </div>
    </div>

  </div>
</div>


<!-- ═══════════════════ Debug Panels ═══════════════════ -->
<div class="row mt-4 mb-2">
  <div class="col">
    <div class="card border-0 shadow-sm">
      <div class="card-header d-flex align-items-center justify-content-between py-2 px-3"
        style="cursor:pointer; background:#f8f9fa; border-radius:6px;" (click)="showSystemStatus = !showSystemStatus">
        <span class="font-weight-semibold text-secondary" style="font-size:13px;">
          <i class="fa fa-server mr-2"></i>System Status Report
        </span>
        <i class="fa" [ngClass]="showSystemStatus ? 'fa-chevron-up' : 'fa-chevron-down'"
          style="font-size:11px; color:#aaa;"></i>
      </div>
      <div *ngIf="showSystemStatus" class="card-body p-0">
        <pre class="m-0 p-3"
          style="background:#1e1e2e; color:#cdd6f4; font-size:12px; border-radius:0 0 6px 6px; max-height:400px; overflow-y:auto;">{{system_status_report | json}}</pre>
      </div>
    </div>
  </div>
</div>

<div class="row mb-4">
  <div class="col">
    <div class="card border-0 shadow-sm">
      <div class="card-header d-flex align-items-center justify-content-between py-2 px-3"
        style="cursor:pointer; background:#f8f9fa; border-radius:6px;" (click)="showUserReport = !showUserReport">
        <span class="font-weight-semibold text-secondary" style="font-size:13px;">
          <i class="fa fa-users mr-2"></i>User Registration Report
        </span>
        <i class="fa" [ngClass]="showUserReport ? 'fa-chevron-up' : 'fa-chevron-down'"
          style="font-size:11px; color:#aaa;"></i>
      </div>
      <div *ngIf="showUserReport" class="card-body p-0">
        <pre class="m-0 p-3"
          style="background:#1e1e2e; color:#cdd6f4; font-size:12px; border-radius:0 0 6px 6px; max-height:400px; overflow-y:auto;">{{user_registration_report | json}}</pre>
      </div>
    </div>
  </div>
</div>


<ng-template #scheduleMaintenance>
  <modal-header>
    <h4 class="modal-title pull-left">Schedule Maintenance Mode</h4>
  </modal-header>
  <div class="modal-body">
    <div class="row">
      <div class="col-auto">
        Reason:
      </div>
      <div class="col-auto">
        <input type="text" [(ngModel)]="maintenance_reason" />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button (click)="confirm_maintenance($event, maintenance_reason)" class="btn btn-info">Submit</button>
  </div>
</ng-template>